import axiosInstance from "@/config/axiosInstance";

// ==================== PUBLIC CATEGORY ENDPOINTS ====================

/**
 * Get all categories
 * @returns {Promise<{data: Array}>}
 */
export const getAllCategories = async () => {
  const response = await axiosInstance.get("/api/categories");
  return response.data;
};

/**
 * Get single category by slug
 * @param {string} slug - Category slug
 * @returns {Promise<{data: Object}>}
 */
export const getCategoryBySlug = async (slug) => {
  const response = await axiosInstance.get(`/api/categories/slug/${slug}`);
  return response.data;
};

// ==================== ADMIN CATEGORY ENDPOINTS ====================

/**
 * Create new category (Admin only - requires JWT)
 * @param {Object} categoryData - Category data
 * @param {string} categoryData.name - Category name
 * @param {string} categoryData.slug - Category slug (optional, auto-generated if not provided)
 * @param {string} categoryData.description - Category description (optional)
 * @returns {Promise<{data: Object}>}
 */
export const createCategory = async (categoryData) => {
  const response = await axiosInstance.post("/api/categories", categoryData);
  return response.data;
};

/**
 * Update existing category (Admin only - requires JWT)
 * @param {number} id - Category ID
 * @param {Object} categoryData - Updated category data
 * @returns {Promise<{data: Object}>}
 */
export const updateCategory = async (id, categoryData) => {
  const response = await axiosInstance.put(`/api/categories/${id}`, categoryData);
  return response.data;
};

/**
 * Delete category (Admin only - requires JWT)
 * @param {number} id - Category ID
 * @returns {Promise<{message: string}>}
 */
export const deleteCategory = async (id) => {
  const response = await axiosInstance.delete(`/api/categories/${id}`);
  return response.data;
};
